<!-- Avatar slot (left side) -->
@if (avatar()) {
  <ng-content select="[hxChipAvatar]" />
}

<span class="hx-chip-label">{{ label() }}</span>

<!-- Trailing icon slot (right side, before remove) -->
@if (trailingIcon()) {
  <ng-content select="[hxChipTrailingIcon]" />
}

<!-- Remove button (Material pattern with HxChipRemove directive) -->
@if (_showRemoveButton()) {
  <button
    class="hx-chip-end"
    type="button"
    title="Remove"
    [attr.aria-label]="'Remove ' + label()"
    [disabled]="disabledState()"
    [stopPropagation]="['click']"
    (click)="remove()">
    <ng-content select="[hxChipRemove]" />
  </button>
}
